<template>
    <painel titulo="Aplicação" icone="pi pi-users">
        <erros-box :erros="erros"></erros-box>
        <div class="formgrid grid p-fluid">
            <div class="field col-12 md:col-3">
                <label>Nome da aplicação</label>
                <InputText type="text" v-model="codigo" :disabled="desabilitarForm" />
            </div>
            <div class="field col-12 md:col-6">
                <label>Descrição aplicação</label>
                <InputText type="text" v-model="descricao" :disabled="desabilitarForm" />
            </div>
            <div class="field col-12 md:col-3">
                <label>Acesso válido até</label>
                <Calendar
                    v-model="fimVigencia"
                    placeholder="dd/mm/aaaa"
                    :monthNavigator="true"
                    v-show="acao != 'D'"
                    :yearNavigator="true"
                    :manualInput="true"
                    :disabled="desabilitarForm"
                />
                <Calendar v-model="fimVigencia" placeholder="dd/mm/aaaa" v-if="desabilitarForm" :disabled="desabilitarForm"></Calendar>
            </div>
            <div class="sm:col-12 md:col-2 mt-3" v-if="desabilitarForm">
                <label class="mr-2">Status</label>
                <status :status="aplicacao ? aplicacao.statusDescr : ''"></status>
            </div>

            <div class="sm:col-12 md:col-4" v-if="desabilitarForm">
                <label class="mr-2">Token válido até</label>
                <InputText v-if="aplicacao" :value="$moment(aplicacao.validadeToken).format('DD/MM/YYYY HH:mm')" :disabled="desabilitarForm" />
            </div>
            <div class="sm:col-12 md:col-4" v-if="desabilitarForm">
                <label class="mr-2">Data de atualização</label>
                <InputText v-if="aplicacao" :value="$moment(aplicacao.dataAtualizacao).format('DD/MM/YYYY HH:mm')" :disabled="desabilitarForm" />
            </div>
        </div>
        <div v-if="desabilitarForm">
            <div class="">
                <h4>Token</h4>
                <span class="token mb-4" v-if="aplicacao">
                    {{ aplicacao.token }}
                </span>
            </div>
        </div>
        <AplicacaoRegrasAcesso @updateRegrasAcessoSelecionadas="updateRegrasAcessoSelecionadas($event)" :aplicacao="aplicacao" :acao="acao" />
        <slot name="botoes"></slot>
        <Button
            label="Salvar"
            icon="pi pi-check-circle"
            class="ml-2 p-button-primary"
            @click="confirmarSalvar()"
            :disabled="v$.$invalid"
            v-if="!desabilitarForm"
        />
        <btn-atualizar v-if="desabilitarForm" :aplicacao="aplicacao"></btn-atualizar>
        <btn-recriar-token :aplicacao="aplicacao" @atualizarAplicacao="aplicacao = $event" v-if="desabilitarForm"></btn-recriar-token>
        <btn-ativar-desativar
            :aplicacao="aplicacao"
            @atualizarErros="erro = $event"
            v-if="desabilitarForm"
            @atualizarAplicacao="aplicacao = $event"
        ></btn-ativar-desativar>
        <btn-voltar :route="voltarParaRotaCerta" />
    </painel>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import AplicacaoRegrasAcesso from './AplicacaoRegrasAcesso.vue';
import { required } from '@vuelidate/validators';
import BtnAtivarDesativar from './BtnAtivarDesativar.vue';
import BtnAtualizar from './BtnAtualizar.vue';
import BtnRecriarToken from './BtnRecriarToken.vue';
import AplicacoesServicos from './services.js';

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        AplicacaoRegrasAcesso,
        BtnAtivarDesativar,
        BtnAtualizar,
        BtnRecriarToken,
    },

    props: {
        erros: {
            type: Array,
        },
    },

    data() {
        return {
            codigo: null,
            descricao: null,
            fimVigencia: null,
            regraAcessoSelecionadas: [],
            aplicacao: null,
            erro: [],
        };
    },

    validations() {
        return {
            codigo: { required },
            descricao: { required },
            fimVigencia: { required },
        };
    },

    created() {
        if (this.acao != 'I' && !this.aplicacao) {
            this.obterAplicacao();
        }
    },

    methods: {
        obterAplicacao() {
            this.$store.dispatch('addRequest');
            AplicacoesServicos.obterPorId(this.$route.params.id).then((response) => {
                if (response) {
                    if (response.success) {
                        this.aplicacao = response.data;
                        this.preencherFormulario();
                    } else {
                        this.$toast.error('Erro ao obter dados da aplicação', 'ERROR', this.$toastConfig.error);
                    }
                }
                this.$store.dispatch('removeRequest');
            });
        },
        updateRegrasAcessoSelecionadas(regrasAcessoSelecionadas) {
            this.regraAcessoSelecionadas = regrasAcessoSelecionadas;
        },

        confirmarSalvar() {
            this.$confirm.require({
                message: `Tem certeza que deseja ${this.acao == 'I' ? 'salvar' : 'atualizar'} a aplicação?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.salvar();
                },
            });
        },

        salvar() {
            if (this.acao == 'I') {
                const aplicacaoDto = {
                    codigo: this.codigo,
                    descricao: this.descricao,
                    fimVigencia: this.$moment(this.fimVigencia, 'DD/MM/YYYY').format('yyyy-MM-DD'),
                    RegrasAcesso: this.regraAcessoSelecionadas,
                };
                this.inserir(aplicacaoDto);
            } else {
                const aplicacaoDto = {
                    codigo: this.codigo,
                    descricao: this.descricao,
                    fimvigencia:
                        this.fimVigencia && this.fimVigencia != 'NÃO ESPECIFICADO' ? this.$moment(this.fimVigencia, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                    RegrasAcesso: this.regraAcessoSelecionadas,
                    AplicacaoId: this.aplicacao ? this.aplicacao.aplicacaoId : null,
                };
                this.atualizar(aplicacaoDto);
            }
        },

        atualizar(aplicacaoParaAtualizar) {
            this.$store.dispatch('addRequest');
            AplicacoesServicos.atualizar(aplicacaoParaAtualizar).then((response) => {
                if (response?.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Aplicação',
                        detail: `Aplicação atualizada com sucesso!`,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Aplicação',
                        detail: `Não foi possível atualizar a aplicação!`,
                        life: 3000,
                    });
                }
                this.toAtualizar();
                this.$store.dispatch('removeRequest');
            });
        },
        preencherFormulario() {
            this.codigo = this.aplicacao.codigo;
            this.descricao = this.aplicacao.descricao;
            this.fimVigencia = this.aplicacao.fimVigencia ? this.$moment(this.aplicacao.fimVigencia).format('DD/MM/YYYY') : 'NÃO ESPECIFICADO';
        },
        inserir(aplicacaoParaInserir) {
            this.$store.dispatch('addRequest');
            AplicacoesServicos.inserir(aplicacaoParaInserir).then((response) => {
                if (response?.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Aplicação',
                        detail: `Aplicação adicionada com sucesso!`,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Aplicação',
                        detail: `Não foi possível adicionar a aplicação!`,
                        life: 3000,
                    });
                }
                this.toListar();
                this.$store.dispatch('removeRequest');
            });
        },
        toAtualizar() {
            this.obterAplicacao();
            this.$router.push({
                name: 'Aplicacoes_Detalhar',
                params: {
                    id: this.aplicacao.aplicacaoId,
                },
            });
        },
        toListar() {
            this.$router.push({ name: 'Aplicacoes' });
        },
    },

    watch: {
        aplicacao() {
            this.preencherFormulario();
        },
    },

    computed: {
        voltarParaRotaCerta() {
            return { name: this.desabilitarForm ? 'Aplicacoes' : 'Aplicacoes_Detalhar' };
        },
        acao() {
            let retorno = '';
            if (this.$route.name == 'Aplicacoes_Inserir') {
                retorno = 'I';
            } else if (this.$route.name == 'Aplicacoes_Atualizar') {
                retorno = 'A';
            } else if (this.$route.name == 'Aplicacoes_Detalhar') {
                retorno = 'D';
            }
            return retorno;
        },
        desabilitarForm() {
            return this.acao == 'D';
        },
    },
};
</script>

<style scoped>
.token {
    max-width: 700px;
    word-wrap: break-word;
    display: block;
    white-space: normal;
}
</style>
